<template>
  <div class="comp-xl-pooltransfer" v-if="visible">
    <jw-modal v-model:visible="visible" :ok-loading="data.loading" :onBeforeOk="recipientOk" @cancel="handleCancel" title-align="start" width="600px" class="recipient">
      <template #title> {{ title }} </template>
      <jw-form :model="data.form" label-align="left" class="recipient-form" ref="personForm" @submit="handleSubmit">
        <jw-form-item field="poolClue" class="recipient-form-item form-label-text" :rules="[{ required: true, message: $t('请选择接收线索池') }]" :validate-trigger="['blur', 'input', 'change']">
          <template #label>
            <xl-label-text :value="$t('接收线索池')" :row="1" />
          </template>
          <jw-select v-model="data.form.poolClue" :placeholder="$t('请选择接收线索池')" :options="options" />
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { poolClueService } from '@/api';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
const emits = defineEmits(['cb', 'cancel']);
const { t } = useI18n();
const data = reactive({
  loading: false,
  businessIds: '', //线索id集合
  form: {
    poolClue: ''
  }
});
const options = ref();
const personForm = ref(null);
const visible = ref(false);
const title = ref('');

const transferShow = (record) => {
  console.log(37, record);
  data.businessIds = record.businessIds;
  data.form.poolClue = '';
  personForm.value?.resetFields();
  title.value = record.title;
  visible.value = true;
};

const getOptions = async (poolId) => {
  data.poolId = poolId;
  try {
    const json = await poolClueService.getPoolclue();
    if (!json.error) {
      const resultOptions = json.result.filter((item) => item.value !== poolId);
      options.value = resultOptions;
    } else {
      Message.error(t('获取失败'));
    }
  } catch (e) {
    console.log(e);
  }
};

// 取消按钮
const handleCancel = () => {
  visible.value = false;
};

const recipientOk = () => {
  console.log(66);
  personForm.value.handleSubmit();
  return false;
};

const updateFollowUser = async () => {
  data.loading = true;
  try {
    const params = {
      businessIds: data.businessIds,
      id: data.form.poolClue
    };
    const json = await poolClueService.poolTo(params);
    if (!json.error) {
      Message.success(t('操作成功'));
      emits('cb');
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
    data.loading = false;
    handleCancel();
  } catch (e) {
    data.loading = false;
    console.log(e);
  }
};

const handleSubmit = ({ values, errors }) => {
  console.log(90, values);
  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    personForm.value.setFields(errorArray);
    // data.visible = true;
    return;
  }
  updateFollowUser();

  console.log('提交');
};

console.log('线索池转移', data);
defineExpose({ transferShow, getOptions });
</script>
<style scoped lang="less">
@import './xl-pool-transfer.less';
</style>
